import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PROPERTY_DETAILS, VIEW_PROFILE } from '../constants/route-path';

const MagicRedirectHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const customerId = params.get('customer_id');
    const propertyId = params.get('property_id');

    if (customerId) {
      const target = `${VIEW_PROFILE}?customer_id=${customerId}`;
      if (location.pathname + location.search !== target) {
        navigate(target);
      }
    } else if (propertyId) {
      const target = `/property/${propertyId}`;
      if (location.pathname !== target) {
        navigate(target);
      }
    }
  }, [location, navigate]);

  return null;
};

export default MagicRedirectHandler;